/*
 * Transparent header — scroll hold.
 *
 * The sticky-header controllers (assets/secondary.js and the inline one in
 * sections/header.liquid) add `.scrolled-past-header` to `.section-header`
 * almost as soon as the page moves (on the first pixel for "always sticky"
 * headers). snippets/transparent-header-css.liquid and
 * snippets/gallery-transparent-header-css.liquid key the transparent look off
 * that class, so on its own the header turned solid instantly.
 *
 * This script adds `.transparent-header-hold` to `.section-header` while the
 * page is scrolled less than `--transparent-header-hold` (a px value the
 * snippets write onto :root from the section/block "Stay transparent for"
 * setting). The snippets treat the hold class as "still transparent", so the
 * solid header only engages once both the sticky controller and this
 * distance agree. With no transparent header on the page the variable is
 * unset and the class is never added. If this script fails to load, the
 * header falls back to the previous `.scrolled-past-header` behaviour.
 */
(() => {
  if (window.transparentHeaderScroll) return;
  window.transparentHeaderScroll = true;

  const HOLD_CLASS = 'transparent-header-hold';
  let ticking = false;

  const update = () => {
    ticking = false;
    const header = document.querySelector('.section-header');
    if (!header) return;
    const hold = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--transparent-header-hold'));
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    header.classList.toggle(HOLD_CLASS, hold > 0 && scrollTop < hold);
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  document.addEventListener('shopify:section:load', requestUpdate);
  document.addEventListener('shopify:section:unload', () => setTimeout(requestUpdate));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
})();
